import { customAxios, FDV_URL, IDUSUARIO } from "../constants";
import { FETCH_PERMISOS } from "./types";
import { evalAction, serverError } from '../utils/actionError';

export function fetchPermisos(numFichaVtaVeh) {
    const config = { headers: { idUsuario: IDUSUARIO } };

    const request = customAxios.get(`${FDV_URL}/maestro/ficha-venta/${numFichaVtaVeh}/listaPermisos`, config)
    .then(({ data }) => evalAction(data, 'listaPermisos'))
    .catch(error => serverError(error, 'listaPermisos'));;;
    return { type: FETCH_PERMISOS, payload: request };
}



// WEBPACK FOOTER //
// ./src/actions/Permisos.js